export const Permissions = {
  AdminAccess: 'admin_access',
  LicenseOps: 'license_ops',
  QuotaOps: 'quota_ops',
  ScrambleOps: 'scramble_ops',
  UserOps: 'user_ops',
  Anything: 'anything',
  AnalyticsManager: 'analytics_manager'
}
